export default [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '.',
  'Backspace', 'Delete',
  'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Up', 'Down'
];
